﻿module Client.ContractPage.CostOfConstruction.Expanded.Expanded

open FSharpPlus
open Fable.React
open Fable.React.Props
open PortalLibs.Client.Components
open ContractPageModel
open Client.ContractPage.CostOfConstruction.Expanded
open Model
open Fulma
open Fable.FontAwesome
open PortalLibs.Shared
open Shared
open Feliz
open Client.ContractPage.CostOfConstruction

let HeaderRow =
  React.memo (
    "HeaderRow",
    (fun (props: {| contractId: ContractId
                    jobPhase: JobPhase
                    dispatch: Msg -> unit
                    Key: string |}) ->
      tr [ OnClick (fun _ ->
             CostOfConstructionPhaseExpansionToggled(props.contractId, props.jobPhase.Code)
             |> props.dispatch) ] [
        td [ Style [
               TextAlign TextAlignOptions.Right
             ] ] [
          strong [] [ props.jobPhase.Code |> str ]
        ]
        td [] [
          a [] [
            div [ Style [
                    Display DisplayOptions.Flex
                    JustifyContent "space-between"
                  ] ] [
              strong [] [ props.jobPhase.Desc |> str ]
              Icon.icon [ Icon.Props [ Style [ Color "#b5b5b5" ] ] ] [
                Fa.i [ Fa.Solid.ChevronUp ] []
              ]
            ]
          ]
        ]
      ]),
    (fun (props: {| contractId: ContractId
                    jobPhase: JobPhase
                    dispatch: Msg -> unit
                    Key: string |}) -> $"HeaderRow-%s{props.Key}")
  )

let CostTotals =
  React.memo (
    "CostTotals",
    (fun (props: {| ContractSettings: ContractSettings
                    JobPhaseCosts: JobPhaseCosts
                    Key: string |}) ->
      if props.JobPhaseCosts.Costs.Length > 1 then
        tr [ Style [ FontSize Config.smallTextSize ] ] [
          yield td [] []
          yield
            td [ Style [
                   TextAlign TextAlignOptions.Right
                 ] ] [
              strong [] [
                span [] [
                  $"%s{props.JobPhaseCosts.Phase.Desc} Total:"
                  |> str
                ]
              ]
            ]
          yield! Utils.totalColumns props.ContractSettings props.JobPhaseCosts.Costs
        ]
      else
        nothing),
    (fun (props: {| ContractSettings: ContractSettings
                    JobPhaseCosts: JobPhaseCosts
                    Key: string |}) -> $"CostTotals-%s{props.Key}")
  )

let view
  contractSettings
  isSuperUser
  contractId
  contract
  details
  detailsExpanded
  searchModels
  attachments
  tableStates
  dispatch
  jobCostSubs
  jobPhaseCosts
  =
  [ yield
      HeaderRow
        {| contractId = contractId
           jobPhase = jobPhaseCosts.Phase
           dispatch = dispatch
           Key = $"CostsExpandedRowHeader-%s{jobPhaseCosts.Phase.Code}" |}
    yield!
      jobPhaseCosts.Costs
      >>= (fun (cost: JobCost) ->
        let details =
          if cost.ActualCostToDate = 0.0 then
            NoDetails
          else
            match detailsExpanded |> Map.containsKey cost.Id, details |> Map.tryFind cost.Id with
            | false, _ -> Collapsed
            | true, None -> Loading
            | true, Some (details: JobCostDetail list) -> Expanded details

        [ yield
            ReactTransitionGroup.AnimatedCreate
              {| Key = $"CostsExpandedRowData-%i{cost.Id}"
                 ContentOpt =
                  Some(
                    CostData.view
                      {| ContractSettings = contractSettings
                         Cost = cost
                         Details = details
                         Dispatch = dispatch
                         Key = $"CostsExpandedRowData-%i{cost.Id}" |}
                  ) |}
          yield
            (ReactTransitionGroup.AnimatedCreate
              {| Key = $"CostDetailTableAndSearch-%i{cost.Id}"
                 ContentOpt =
                  match details with
                  | NoDetails
                  | Loading
                  | Collapsed -> None
                  | Expanded details ->
                    Some(
                      CostDetailTable.View
                        {| details = details
                           contract = contract
                           jobCost = cost
                           attachments = (attachments |> Map.tryFind cost.Id)
                           searchModels = searchModels
                           tableStates = tableStates
                           isSuperUser = isSuperUser
                           Key = $"CostDetailTableAndSearch-%i{cost.Id}"
                           dispatch = dispatch |}
                    ) |})
          yield
            ReactTransitionGroup.AnimatedCreate
              {| Key = $"CostPoSlView-%i{cost.Id}-PO"
                 ContentOpt =
                  Some(
                    PoSl.View
                      {| costs = jobCostSubs
                         costId = cost.Id
                         subType = JobCostSubType.PO
                         Key = $"CostPoSlView-%i{cost.Id}-PO" |}
                  ) |}
          yield
            ReactTransitionGroup.AnimatedCreate
              {| Key = $"CostPoSlView-%i{cost.Id}-SL"
                 ContentOpt =
                  Some(
                    PoSl.View
                      {| costs = jobCostSubs
                         costId = cost.Id
                         subType = JobCostSubType.SL
                         Key = $"CostPoSlView-%i{cost.Id}-SL" |}
                  ) |}
                  ])
    yield
      ReactTransitionGroup.AnimatedCreate
        {| Key = $"CostSubTotalsRow-%s{jobPhaseCosts.Phase.Code}"
           ContentOpt =
            Some(
              CostTotals
                {| ContractSettings = contractSettings
                   JobPhaseCosts = jobPhaseCosts
                   Key = $"CostSubTotalsRow-%s{jobPhaseCosts.Phase.Code}" |}
            ) |} ]
